module.exports = __webpack_public_path__ + "media/images/countrysquared/sl-e66d43d09a0ad0e5aa0414f7ef6463ef.svg";